import {
   Patient,
   PatientGroup,
   PatientGroupAssignment,
   PatientGroupAssignmentQuery,
   PatientGroupQuery,
} from '@dreryk/egabinet-patient-frontend-api';
import { PatientId } from '@dreryk/egabinet-patient-published-language-api';

import { useCqrsSearch } from '@dreryk/command-query-react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';
import { commonTranslationKeys } from '@dreryk/react-common';
import { Slot } from '@dreryk/watermelon';

type PatientGroupsAssignmentsFormLoaderRenderProps = {
   patientGroups: PatientGroup[];
   assignedPatientGroups: PatientGroupAssignment[];
};

type PatientGroupsAssignmentsFormLoaderProps = {
   patientId: Patient['id'];
   children: (renderProps: PatientGroupsAssignmentsFormLoaderRenderProps) => JSX.Element;
};

export const PatientGroupsAssignmentsFormLoader = (props: PatientGroupsAssignmentsFormLoaderProps): JSX.Element => {
   const { data: patientGroups, loading: patientGroupLoading, error: patientGroupError } = useCqrsSearch<PatientGroup>(
      () => new PatientGroupQuery()
   );

   const {
      data: assignedPatientGroups,
      loading: assignedPatientGroupsLoading,
      error: assignedPatientGroupsError,
   } = useCqrsSearch<PatientGroupAssignment>(() => {
      const query = new PatientGroupAssignmentQuery();
      query.patientId = Slot.of(PatientId.of(props.patientId));
      return query;
   });

   if (patientGroupLoading || assignedPatientGroupsLoading) {
      return <LoaderSpinner />;
   }

   if (patientGroupError || assignedPatientGroupsError) {
      return (
         <Message
            testId={'patientGroupsFetchError'}
            type={MessageType.NEGATIVE}
            label={commonTranslationKeys.unexpectedErrorHasOccurred}
            displayIndicator
         />
      );
   }

   return props.children({
      patientGroups: patientGroups,
      assignedPatientGroups: assignedPatientGroups,
   });
};
